<template>
  <transition name="fade">
    <div
      class="popup-modal" @click.stop
      v-show="show"
      :style="{
        background: mask ? 'rgba(0, 0, 0, 0.6)' : 'rgba(0, 0, 0, 0)',
      }"
    >
    <!-- height: final_height -->
      <div
        class="popup-content"
        :style="{ width: final_width,'min-height':0 }"
      >
        <img
          src="../assets/images/close@2x.png"
          alt=""
          class="icon-close"
          @click.stop="close_modal"
        />
        <slot name="default"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Popup",
  props: {
    mask: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "320px",
    },
    height: {
      type: String,
      default: "310px",
    },
    show: Boolean,
  },
  watch:{
    height:{
      handler(newVal,oldVal){
        console.log('newVal',newVal);
        this.$forceUpdate();
      },
      immediate:true
    }
  },
  data() {
    return {
      top: "0px",
    };
  },
  computed: {
    getOneVwInPixels() {
      return window.innerWidth / 100; // 1vw = 视口宽度 / 100
    },
    final_width() {
      let num = this.width.slice(0, -2);

      if (isNaN(num)) {
        return this.width;
      } else {
        return num / this.getOneVwInPixels + "vw";
      }
    },
    final_height() {
      let num = this.height.slice(0, -2);
      if (isNaN(num)) {
        return this.height;
      } else {
        return num / this.getOneVwInPixels + "vw";
      }
    },
  },
  methods: {
    close_modal() {
      this.$emit("update:show", false);
      this.$emit("on-close");
    },
  },
  created() {
    // let height = this.height.slice(0, -2);
    // this.top = (window.innerHeight - height) / 2 + "px";
    this.$nextTick(() => {
      if (!this.show) return;

      // 获取实际渲染高度
      const contentEl = this.$el.querySelector(".popup-content");
      if (!contentEl) return;

      // 现代浏览器标准方式
      const { height } = contentEl.getBoundingClientRect();
      this.top = `${(window.innerHeight - height) / 2}px`;

      // 兼容性备用方案
      const visualHeight = Math.max(
        contentEl.offsetHeight,
        contentEl.clientHeight,
        contentEl.scrollHeight
      );
      this.top = `${(window.innerHeight - visualHeight) / 2}px`;
    });
  },
};
</script>

<style scoped lang="scss">
.popup-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  cursor: auto;
  display:flex;
  align-items:center;
  justify-content:center;

  .popup-content {
    position: relative;
    background: white;
    // margin: 0 auto;
    border-radius: 10px;
    padding: 10px;
    z-index: 1000;

    .icon-close {
      position: absolute;
      width: 18px;
      height: 18px;
      top: 25px;
      right: 25px;
      cursor: pointer;
      z-index:99;
    }
  }
}
</style>
